<!--
 * @Author: 
 * @Date: 2022-06-21 09:17:53
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-02 10:32:21
 * @FilePath: /Cup2Market/src/views/GoodsDetail/indexPreview.vue
 * @Description: 
-->

<template>
  <div>
    <!-- 商品详情页预览页 -->
    <CustomPage :noTitle="true">
      <div slot="content">
        <div class="goods-detail" style="padding-top: 54px">
          <NavBar
            class="py-1"
            left-arrow
            fixed
            style="background-color: transparent"
          >
            <template #left>
              <Icon name="arrow-left" color="black" size="24" />
            </template>
            <template #right>
              <div class="w-32 flex justify-end pt-2">
                <div class="inline-block ml-2">
                  <img
                    height="24"
                    width="24"
                    src="@/assets/goodsdetail/forwardblack.svg"
                    alt
                  />
                  <div class="text-xxs text-center font-light">转发</div>
                </div>
                <div class="inline-block ml-2">
                  <!-- @click="$router.push({ name: 'HomeMessage' })" -->
                  <div
                    v-if="messageTotal"
                    class="bg-red w-4 h-4 rounded-full absolute text-xs text-white mr-1"
                    style="right: 4px; transform: scale(0.9)"
                  >
                    <span>{{ messageTotal }}</span>
                  </div>
                  <img
                    height="24"
                    width="24"
                    src="@/assets/goodsdetail/messageblack.svg"
                    alt
                  />
                  <div class="text-xxs text-center font-light">消息</div>
                </div>
              </div>
            </template>
          </NavBar>
          <div class="swipContant" v-if="goodsDetail.stock == 0">
            <SwipeImgAndVideo
              :goodsDetail="goodsDetail"
              @change="onChange"
              @click="onSwipeClick"
              :current="current"
            ></SwipeImgAndVideo>
            <img
              src="@/assets/goodsdetail/soldOut.svg"
              alt
              class="soldOutImg"
            />
          </div>
          <!-- //非售罄结构 -->
          <div class="swipContant" v-else>
            <SwipeImgAndVideo
              :goodsDetail="goodsDetail"
              @change="onChange"
              :current="current"
              @click="onSwipeClick"
            ></SwipeImgAndVideo>
          </div>
          <div class="mx-3 pb-6 mt-2">
            <div class="title-wrapper">
              <div class="tit text-xs font-semibold text-left">
                {{ goodsDetail.goodsName }}
              </div>
              <div class="buy-quantity" v-if="goodsDetail.buyQuantity">
                {{
                  goodsDetail.buyQuantity > 100
                    ? goodsDetail.buyQuantity + "+"
                    : goodsDetail.buyQuantity
                }}人付款
              </div>
            </div>
            <div
              class="flex flex-row justify-between text-red font-semibold"
              :class="{ soldOutPrice: goodsDetail.stock == 0 }"
            >
              <div
                :class="goodsDetail.state === 'IN_PROGRESS' ? '' : 'text-green'"
              >
                <span class="text-sm">¥</span>
                <span class="text-2xl mr-2">
                  {{
                    goodsDetail.actPrice === 0
                      ? 0
                      : goodsDetail.actPrice
                      ? goodsDetail.actPrice.toFixed(2)
                      : ""
                  }}
                </span>
                <span
                  class="text-xs line-through font-normal"
                  style="color: #808080"
                  >¥{{ goodsDetail.linePrice }}</span
                >
              </div>
              <div v-distributor="true" class="font-xxxs">
                省赚¥
                <span class="text-2xl">
                  {{ goodsDetail.saveProfit }}
                  <span
                    class="text-xl"
                    v-if="goodsDetail.activityReward === 'COMMISSION'"
                    >*2</span
                  >
                </span>
              </div>
            </div>
            <div
              v-distributor="true"
              class="flex flex-row justify-between mb-2 mt-1"
            >
              <div
                class="flex w-14 justify-between items-center rounded-full px-2"
                style="background-color: #f8f8f8; color: #808080"
              >
                <img
                  height="12px"
                  width="12px"
                  class="flex-grow-0 flex-shrink-0"
                  src="@/assets/goodsdetail/messagegray.svg"
                  alt
                />
                <div class="flex-grow text-xs ml-1">咨询</div>
              </div>
              <div
                class="inline-block bg-red text-white rounded-full py-1 px-2 text-xs text-center"
                style="width: 6rem; max-height: 29px"
              >
                <!-- @click="shareClick" -->
                分享赚钱&nbsp;
                <img
                  class="inline"
                  style="height: 0.75rem"
                  src="@/assets/home/fenxiangzhuanqian.svg"
                  alt
                />
              </div>
            </div>
            <div class="lightshadow rounded-lg flex flex-col p-3 font-xxxs">
              <div class="flex mb-1 items-center">
                <div class="flex-shrink-0 mr-2" style="color: #808080">
                  服务
                </div>
                <div
                  class="flex-grow text-left"
                  v-if="goodsDetail.partServices"
                >
                  {{
                    goodsDetail.partServices
                      .map((service) => service.name)
                      .join("·")
                  }}
                </div>
                <Icon
                  name="arrow"
                  color="black"
                  size="10"
                  class="font-extrabold float-right flex-shrink-0"
                />
              </div>
              <div class="flex mb-1">
                <div class="flex-shrink-0 mr-2" style="color: #808080">
                  发货
                </div>
                <div class="flex-grow text-left" v-if="goodsDetail.deliverDay">
                  最晚于{{
                    dayjs()
                      .add(goodsDetail.deliverDay, "day")
                      .format("MM[月]DD[日]")
                  }}，从{{
                    CodeToText[JSON.parse(goodsDetail.deliverAddress)[0]] +
                    CodeToText[JSON.parse(goodsDetail.deliverAddress)[1]] +
                    CodeToText[JSON.parse(goodsDetail.deliverAddress)[2]]
                  }}发货
                </div>
              </div>
              <div
                v-if="couponList.length"
                class="flex flex-row items-center justify-between flex-no-wrap mb-1"
              >
                <span>
                  <span class="mr-2" style="color: #808080">优惠</span>
                  <!-- <span
                    v-for="item in couponList"
                    :key="item.couponId"
                    class="font-xxxs text-red border-red1px rounded px-1 mr-1"
                  >
                    {{
                      item.threshold
                        ? "满" + item.threshold + "减" + item.faceValue
                        : "减" + item.faceValue
                    }}
                  </span> -->
                </span>
                <span class="text-red-500 flex items-center font-xxxs">
                  <!-- @click="showCoupon = true" -->
                  领券
                  <Icon
                    name="arrow"
                    color="red"
                    size="10"
                    class="font-extrabold float-right flex-shrink-0"
                  />
                </span>
              </div>
              <div
                v-if="goodsDetail.activityReward"
                class="flex flex-row items-center justify-between flex-no-wrap"
              >
                <span>
                  <span class="mr-2" style="color: #808080">活动</span>
                  <iframe
                    class="img"
                    v-if="goodsDetail.activityReward === 'AWARD'"
                    :src="require('@/assets/goodsdetail/抽奖专场.svg')"
                  ></iframe>
                  <iframe
                    class="img"
                    v-if="
                      goodsDetail.activityReward === 'COMMISSION' &&
                      $store.state.user.distributionFlag
                    "
                    :src="require('@/assets/goodsdetail/双倍佣金.svg')"
                  ></iframe>
                  <iframe
                    class="img"
                    v-if="goodsDetail.activityReward === 'NEWBIE'"
                    :src="require('@/assets/goodsdetail/新人专场.svg')"
                  ></iframe>
                </span>
              </div>
            </div>
            <div
              v-if="goodsDetail.goodsSpecs.length"
              class="lightshadow p-3 rounded-lg mt-3 mb-1"
            >
              <div class="flex justify-between items-center text-xs">
                <!-- @click="showSku('both')" -->
                <span style="color: #808080">选择</span>
                <span class="flex-grow font-semibold text-left px-3">
                  {{
                    goodsDetail.goodsSpecs
                      .map((item) => item.specName)
                      .join("/")
                  }}
                </span>
                <Icon
                  name="arrow"
                  color="black"
                  size="10"
                  class="font-extrabold float-right flex-shrink-0"
                />
              </div>
            </div>
            <Tabs v-if="$store.state.user.distributionFlag" class="mb-12">
              <Tab>
                <template #title>
                  <span class="font-xxxs">商品详情</span>
                </template>
                <div v-html="goodsDetail.footage"></div>
              </Tab>
              <Tab>
                <template #title>
                  <span class="font-xxxs">精选素材</span>
                </template>
                <DiscoverList :goodsId="goodsDetail.goodsId" />
              </Tab>
            </Tabs>
            <div v-else v-html="goodsDetail.footage"></div>
          </div>
          <ActionSheet v-model="showCoupon" title="优惠券">
            <div class="m-3 overflow-y-auto" style="max-height: 21rem">
              <div
                v-for="item in couponList"
                :key="item.id"
                class="rounded-md border flex flex-row text-white mb-3 items-center justify-between pr-3"
                :style="{
                  borderColor:
                    item.getstatus !== 'got' && !item.isClaim
                      ? '#E89A52'
                      : '#CECECE',
                }"
              >
                <div
                  class="w-40 flex flex-col justify-center items-center p-3"
                  :style="{
                    background:
                      item.getstatus !== 'got' && !item.isClaim
                        ? 'linear-gradient(90deg, #FBC787 0%, #E79950 100%)'
                        : '#CECECE',
                  }"
                >
                  <div>
                    <span class="text-xl">¥&nbsp;</span>
                    <span
                      class="leading-10 font-semibold"
                      style="letter-spacing: 0.1rem; font-size: 2.5rem"
                      >{{ item.faceValue }}</span
                    >
                  </div>
                  <div class="text-xs">
                    满{{ item.threshold ? item.threshold : "任意" }}元可用
                  </div>
                </div>
                <div class="text-left flex-grow ml-3">
                  <div class="text-black text-sm mb-1">
                    {{ item.couponName }}
                  </div>
                  <div class="text-xs text-gray">
                    {{ item.startDate }} - {{ item.endDate }}
                  </div>
                </div>
                <div>
                  <Button
                    :disabled="item.getstatus === 'got' || item.isClaim"
                    class="w-20"
                    style="padding-left: 12px; padding-right: 12px"
                    round
                    :color="
                      item.getstatus !== 'got' && !item.isClaim
                        ? '#E89A52'
                        : '#CECECE'
                    "
                    size="mini"
                  >
                    <!-- @click="getCoupon(item)" -->
                    {{
                      item.getstatus !== "got" &&
                      !item.isClaim &&
                      item.remainNum !== 0
                        ? "立即领取"
                        : item.remainNum === 0
                        ? "已领完"
                        : "已领取"
                    }}
                  </Button>
                </div>
              </div>
            </div>
            <div class="mx-3 mb-3">
              <Button
                style="padding-left: 12px; padding-right: 12px"
                round
                color="linear-gradient(135deg, #E82237 0%, #FF9D9D 100%)"
                size="large"
                >完成</Button
              >
              <!-- @click="showCoupon = false" -->
            </div>
          </ActionSheet>
          <Overlay :show="diagVisible">
            <!-- @click=" () => { diagVisible = false; showShare = false; } " -->
            <div
              v-show="!showShare"
              class="wrapper mx-12"
              :class="showInput ? '-my-2' : 'my-12'"
            >
              <!-- @click.stop -->
              <div class="bg-white rounded-lg mb-6 overflow-auto p-3 text-left">
                <div class="flex items-center mb-2">
                  <div
                    style="height: 46px; width: 46px"
                    class="flex-shrink-0 mr-3"
                  >
                    <img
                      :src="forwardDetail.logoUrl"
                      class="h-full w-full rounded"
                      alt
                    />
                  </div>
                  <div class="flex flex-col">
                    <div class="text-xs font-semibold">
                      {{ forwardDetail.activityName }}
                    </div>
                    <div class="text-xs">{{ forwardDetail.brandName }}</div>
                  </div>
                </div>
                <div class="flex justify-center">
                  <div style="height: 182px; width: 182px" class="mr-1">
                    <img
                      :src="forwardDetail.posterImg"
                      class="h-full w-full rounded"
                      alt
                    />
                  </div>
                  <div class="flex flex-col justify-between">
                    <img
                      style="height: 89px; width: 89px"
                      :src="forwardDetail.rightImgOne"
                      alt
                      class="rounded"
                    />
                    <img
                      style="height: 89px; width: 89px"
                      :src="forwardDetail.rightImgTwo"
                      alt
                      class="rounded"
                    />
                  </div>
                </div>
                <div class="text-xs py-1">{{ forwardDetail.goodsName }}</div>
                <div v-show="defaultSpec" class="text-xs">
                  规格:{{
                    forwardDetail.specDetailList
                      ? forwardDetail.specDetailList.join("/")
                      : ""
                  }}
                </div>
                <div
                  class="flex justify-between mb-3"
                  style="white-space: nowrap"
                >
                  <div class="text-red">
                    <span class="text-xs">¥</span>
                    <span class="font-semibold mr-2">
                      {{ forwardDetail.price }}
                    </span>
                    <span class="text-xxs font-semibold"
                      >赚：{{ forwardDetail.saveProfit }}元</span
                    >
                  </div>
                  <div class="text-xs">
                    {{
                      dayjs(forwardDetail.activityTime).format(
                        "MM[月]DD[日] HH:mm"
                      )
                    }}结束
                  </div>
                </div>
                <div>
                  <div class="text-xs">加价：</div>
                  <div class="flex justify-between text-xs -mx-1 mb-2">
                    <div
                      style="background-color: #f1f1f1"
                      class="h-8 leading-8 mx-1 flex-grow text-center rounded"
                      :class="{ activejiajia: jiajiaway === 1 }"
                    >
                      <!-- @click="() => (jiajiaway = 1)" -->
                      不加价
                    </div>
                    <div
                      style="background-color: #f1f1f1"
                      class="h-8 leading-8 mx-1 flex-grow text-center rounded"
                      :class="{ activejiajia: jiajiaway === 2 }"
                    >
                      <!-- @click="() => (jiajiaway = 2)" -->
                      加价10元
                    </div>
                    <div
                      style="background-color: #f1f1f1"
                      class="h-8 leading-8 mx-1 flex-grow text-center rounded"
                      :class="{ activejiajia: jiajiaway === 3 }"
                    >
                      <!-- @click="() => (jiajiaway = 3)" -->
                      加价20%
                    </div>
                  </div>
                  <div>
                    <Field
                      class="rounded h-8 pt-1"
                      :class="jiajiaway === 4 ? 'border-red-500 border' : ''"
                      style="background-color: #f1f1f1"
                      placeholder="自定义金额"
                      input-align="center"
                      readonly
                      clickable
                      :value="customjiajia"
                    />
                    <!-- @touchstart.native.stop=" () => { jiajiaway = 4; showInput = true; } " -->
                  </div>
                </div>

                <!-- <NumberKeyboard
                  v-model="customjiajia"
                  :show="showInput"
                  theme="custom"
                  extra-key="."
                  close-button-text="完成"
                  @blur="showInput = false"
                /> -->
              </div>
              <Button
                style="height: 2rem"
                round
                color="linear-gradient(135deg, #E82237 0%, #FF9D9D 100%)"
                size="large"
                v-gapclick="generatePost"
                >生成海报</Button
              >
            </div>
          </Overlay>
          <Overlay :show="showOverlay2"></Overlay>

          <!-- @click=" () => { showOverlay2 = false; showShare = false; } " -->

          <GoodsAction>
            <GoodsActionIcon text="首页">
              <!-- @click="$router.push({ name: 'Home' })" -->
              <template #icon>
                <img :src="require('@/assets/tabbar/shouye.svg')" alt />
              </template>
            </GoodsActionIcon>
            <GoodsActionIcon text="购物车">
              <!-- @click="$router.push({ name: 'Cart' })" -->
              <template #icon>
                <img :src="require('@/assets/tabbar/gouwuche.svg')" alt />
              </template>
            </GoodsActionIcon>

            <!-- 售罄结构 -->
            <template v-if="goodsDetail.stock == 0">
              <GoodsActionButton color="#808080" text="售罄" />
            </template>

            <!-- 非售罄结构 -->
            <template v-else>
              <GoodsActionButton
                v-if="goodsDetail.state === 'IN_PROGRESS'"
                color="white"
                type="warning"
                text="加入购物车"
                class="border-red1px"
                @click="showSku('cart')"
              >
                <template #default>
                  <span class="text-red">加入购物车</span>
                </template>
              </GoodsActionButton>

              <GoodsActionButton
                v-else
                color="white"
                type="warning"
                text="加入购物车"
                class="border-green1px"
                @click="showSku('cart')"
              >
                <template #default>
                  <span class="text-green">加入购物车</span>
                </template>
              </GoodsActionButton>

              <GoodsActionButton
                v-if="goodsDetail.state === 'IN_PROGRESS'"
                color="#E82035"
                type="danger"
                text="立即购买"
                @click="showSku('buy')"
              />
              <GoodsActionButton
                v-else
                color="#44d7b6"
                type="danger"
                text="即将上线"
              />
            </template>
          </GoodsAction>

          <Sku
            v-model="show"
            :sku="sku"
            :goods="goods"
            :goods-id="partGoodsId"
            :quota="quota"
            :quota-used="quotaUsed"
            :hide-stock="sku.hide_stock"
            :initialSku="initialSku"
            @sku-selected="skuSelected"
            @close-preview="closePreview"
            ref="sku"
          >
            <!-- @buy-clicked="onBuyClicked" @add-cart="onAddCartClicked" -->
            <template #sku-header="{ price, selectedSkuComb, selectedSku }">
              <div class="van-sku-header van-hairline--bottom">
                <div class="van-image van-sku-header__img-wrap">
                  <!-- @click="onPreview" -->
                  <img :src="goods.picture" alt />
                </div>
                <div class="van-sku-header__goods-info">
                  <div class="van-sku__goods-price">
                    <span class="van-sku__price-symbol">￥</span>
                    <span class="van-sku__price-num">{{ price }}</span>
                    <span
                      v-if="
                        selectedSkuComb && $store.state.user.distributionFlag
                      "
                      class="ml-2"
                    >
                      返现￥
                      {{ selectedSkuComb.saveProfit }}
                      <template
                        v-if="goodsDetail.activityReward === 'COMMISSION'"
                        >*2</template
                      >
                    </span>
                  </div>

                  <div class="van-sku-header-item">
                    <span class="van-sku__stock">
                      剩余
                      <span class="van-sku__stock-num">
                        {{
                          selectedSkuComb && selectedSkuComb.stock_num
                            ? selectedSkuComb.stock_num
                            : goodsDetail && goodsDetail.stock
                        }}
                      </span>
                      件
                    </span>
                  </div>

                  <div class="van-sku-header-item" v-if="!selectedSkuComb">
                    请选择&nbsp;规格
                  </div>
                  <div class="van-sku-header-item" v-else>
                    已选择&nbsp;{{
                      selectedSkuComb[Object.keys(selectedSku)[0]]
                        | formatSpecification
                    }}
                  </div>
                </div>
              </div>
            </template>
            <template #sku-actions>
              <!-- <template #sku-actions="props"> -->
              <div class="van-sku-actions">
                <template v-if="goodsDetail.stock == 0">
                  <!-- 售罄结构 -->
                  <GoodsActionButton color="#808080" text="售罄" />
                </template>

                <template v-else>
                  <!-- 非售罄结构 -->

                  <Button
                    v-if="cartBtn !== 'buy'"
                    square
                    size="large"
                    type="warning"
                    style="background: white; color: #e82035"
                    :style="{
                      border:
                        goodsDetail.state === 'IN_PROGRESS'
                          ? '#e82035 1px solid'
                          : '#44d7b6 1px solid',
                      color:
                        goodsDetail.state === 'IN_PROGRESS'
                          ? '#e82035'
                          : '#44d7b6',
                    }"
                    >加入购物车</Button
                  >
                  <!-- @click="props.skuEventBus.$emit('sku:addCart')" -->
                  <!-- 直接触发 sku 内部事件，通过内部事件执行 onBuyClicked 回调 -->
                  <!-- @click="props.skuEventBus.$emit('sku:buy')" -->
                  <Button
                    v-if="cartBtn !== 'cart'"
                    square
                    size="large"
                    type="danger"
                    :style="{
                      background:
                        goodsDetail.state === 'IN_PROGRESS'
                          ? 'linear-gradient(135deg, #e82237 0%, #ff9d9d 100%)'
                          : '#44D7B6',
                    }"
                    >立即购买</Button
                  >
                </template>
              </div>
            </template>
          </Sku>
        </div>
      </div>
    </CustomPage>
  </div>
</template>

<script>
import SwipeImgAndVideo from "./components/SwipeImgAndVideo.vue";
import CustomPage from "@/components/preview-custom-page.vue";
import DiscoverList from "@/views/GoodsDetail/components/DiscoverList";
import {
  NavBar,
  Icon,
  Swipe,
  SwipeItem,
  Tabs,
  Tab,
  ActionSheet,
  Overlay,
  Button,
  NumberKeyboard,
  Field,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Sku,
  ImagePreview,
  Toast,
  Image as VImage,
} from "vant";
import { CodeToText } from "element-china-area-data";
import {
  getPreviewGoodsDetail,
  addCart,
  getCouponCenter,
  getCoupon,
} from "./webApi";
import { accessLog } from "@/api/index";
import { priceMarkup, forwardDetail } from "@/api/forward.js";
import { isWechatMP } from "@/utils/qiyukf";
let that; // that 定义全局 才能拿到data
export default {
  components: {
    SwipeImgAndVideo,
    CustomPage,
    DiscoverList,
    NavBar,
    Icon,
    // Swipe,
    // SwipeItem,
    Tabs,
    Tab,
    ActionSheet,
    Overlay,
    Button,
    // NumberKeyboard,
    Field,
    GoodsAction,
    GoodsActionIcon,
    GoodsActionButton,
    Sku,
  },

  beforeCreate() {
    that = this; // that 定义全局 才能拿到data
  },
  created() {
    this.$store.dispatch("app/showLoading");
    // MARK:
    const params = { id: this.$route.params.id, key: this.$route.query.key };
    getPreviewGoodsDetail(params)
      .then((res) => {
        console.log(res, "res");
        const { data } = res;
        if (data.state === "FINISHED") {
          Toast({
            message: "活动已结束",
            position: "center",
            duration: 1000,
          });

          //oldPage 用于判断活动结束 返回到原先页面
          if (this.$route.query.oldPage) {
            this.$router.back();

            // name: 'OrderAfterSaleGoodsDetail',
            // query: { id: this.$route.query.id },
          } else {
            this.$router.push("/");
          }
        }
        if (data.distMarkup) {
          data.actPrice += data.distMarkup;
          data.goodsInfos.forEach((item) => {
            item.actPrice += data.distMarkup;
          });
        }

        this.goodsDetail = data;
        // 处理goodsVideo
        // 从 goodsDetail取出goodsVideo,如果goodsVideo存在,则把goodsVideo放到goodsDetail.goodsImages的第一个位置
        if (this.goodsDetail.goodsVideo) {
          this.goodsDetail.goodsImages.unshift({
            url: this.goodsDetail.goodsVideo,
            isVideo: true,
          });
        }

        this.goodsImg = data.goodsImg;
        console.log(11111, this.goodsDetail);
        this.goods.picture = data.goodsImg;
        this.sku.price = data.actPrice;
        this.sku.stock_num = data.stock;

        this.partGoodsId = data.partGoodsId;
        // if (!this.$store.state.user.distributionFlag) {
        accessLog({ type: "goods", id: data.partGoodsId });
        // }

        let tree = [];
        data.goodsSpecs.map((item) => {
          if (item.defaults) this.defaultSpec = item.specName;
          let tempV = [];
          data.goodsSpecDetails.map((item2) => {
            if (item2.specId === item.specId) {
              tempV.push({
                id: item2.specDetailId,
                name: item2.detailName,
              });
            }
          });
          tree.push({
            k: item.specName,
            k_id: item.specId,
            v: tempV,
            k_s: item.specName,
          });
        });
        console.log("tree!", tree);

        let list = [];
        data.goodsInfos.map((item) => {
          let temp = {
            // id: item.partGoodsInfoId,
            id: item.goodsInfoId,
            price: item.actPrice * 100,
            stock_num: item.stock,
            saveProfit: item.saveProfit,
          };
          item.goodsInfoSpecDetails.map((item2) => {
            temp[item2.specName] = item2.specDetailId;
            // temp[item2.specName] = item2.specDetailId;
          });
          list.push(temp);
        });

        this.sku.tree = tree;
        this.sku.list = list;
        this.$store.dispatch("app/hideLoading");
        const params = {
          actId: this.goodsDetail.actId,
          goodsId: this.goodsDetail.goodsId,
        };
        getCouponCenter(params).then(({ data }) => {
          this.couponList = data;
        });
      })
      .catch((e) => {
        this.$store.dispatch("app/hideLoading");
      });
  },
  filters: {
    formatSpecification(val) {
      if (val) {
        // that 定义全局 才能拿到data
        const choosedObj = that.goodsDetail.goodsSpecDetails.find((item) => {
          return item.specDetailId === val;
        });
        return choosedObj.detailName;
      }
      return "";
    },
  },
  mounted() {
    if (this.$route.params.showCart) {
      this.showSku("cart");
    }
  },
  updated() {
    // 客服消息监听
    if (!isWechatMP()) {
      ysf("onunread", function (result) {
        this.qiyuTotal = result.total;
      });
    }
  },
  data() {
    return {
      initialSku: {}, //默认选中
      ImagePreviewIndex: 0,
      qiyuTotal: 0,

      CodeToText: CodeToText,
      current: 0,
      activeSku: "",
      goodsDetail: { goodsSpecs: [], goodsId: null },
      defaultSpec: null,
      // ==========================分享赚钱部分开始======================================
      forwardDetail: {},
      diagVisible: false,
      showOverlay2: false,
      showInput: false,
      customjiajia: "",
      jiajiaway: 1,
      urlAddress: null,
      showShare: false,

      browserType: localStorage.getItem("browserType"),
      // ==========================分享赚钱部分结束======================================
      // ======================领券部分======================
      showCoupon: false,
      couponList: [],
      // ======================领券部分======================
      // =============================================sku部分开始=============================================
      cartBtn: "both",
      partGoodsId: "",
      quota: 0, //限购数，0 表示不限购
      quotaUsed: 0, //已经购买过的数量
      show: false,
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。

        tree: [],

        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [],
        price: "1.00", // 默认价格（单位元）
        stock_num: 0, // 商品总库存
        collection_id: 2261, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: false, // 是否无规格商品

        hide_stock: false, // 是否隐藏剩余库存
      },
      goods: {
        // 默认商品 sku 缩略图
        picture: "",
      },

      // =============================================sku部分结束=============================================
    };
  },
  computed: {
    messageTotal() {
      return this.qiyuTotal + this.$store.state.app.messageNum;
    },
  },
  methods: {
    onPreview() {
      const imgs = this.goodsDetail.goodsInfos.map((v) => {
        return v.goodsInfoImg;
      });

      const this_ = this;
      ImagePreview({
        images: imgs,
        startPosition: this.ImagePreviewIndex,
        onClose(urlObj) {
          const specName = this_.goodsDetail.goodsSpecs[0].specName;

          console.log(this_.goodsDetail.goodsInfos[urlObj.index]);

          this_.initialSku = {};
          this_.$set(
            this_.initialSku,
            specName,
            this_.goodsDetail.goodsInfos[urlObj.index].goodsInfoSpecDetails[0]
              .specDetailId
          );

          // this_.initialSku = {
          //   specName:
          //     this_.goodsDetail.goodsInfos[urlObj.index].goodsInfoSpecDetails[0]
          //       .specDetailId,
          // }
          // this_.$refs.sku.resetSelectedSku()
        },
      });
    },
    closePreview(v) {
      console.log(this.sku.tree);
      console.log(this.$refs.sku);
      console.log(v);
    },
    getCoupon(item) {
      getCoupon(item.couponId).then((res) => {
        Toast({
          message: res.message,
          position: "center",
          duration: 1000,
        });
        this.$set(item, "getstatus", "got");
      });
    },
    onChange(index) {
      this.current = index;
      console.log(index, "onChange Swipe");
    },
    onSwipeClick(e) {
      console.log(e, " onSwipeClick");
    },
    changeActiveSku(item) {
      this.activeSku = item.partGoodsInfoId;
      ImagePreview([item.goodsInfoImg]);
    },
    shareClick() {
      this.$store.dispatch("shareGoods/show", {
        params: {
          partId: this.goodsDetail.partId,
          actId: this.goodsDetail.actId,
          partGoodsId: this.goodsDetail.partGoodsId,
          goodsId: this.goodsDetail.goodsId,
        },

        shareOptions: {
          title: this.goodsDetail.goodsName,
          desc: null,
          imgUrl: this.goodsDetail.goodsImages[0]?.url,
        },
      });
    },
    // ----- 废弃 -----
    showDiag() {
      forwardDetail({
        actId: this.goodsDetail.actId,
        partId: this.goodsDetail.partId,
        partGoodsId: this.goodsDetail.partGoodsId,
        goodsId: this.goodsDetail.goodsId,
        suitId: null,
        customerId: null,
        retailId: null,
        forwardType: "GOODS",
      }).then(({ data }) => {
        this.forwardDetail = data;
        this.diagVisible = true;
      });
    },
    showSku(value) {
      this.cartBtn = value;
      this.show = true;
    },
    skuSelected(skuValue) {
      console.log(skuValue);
      if (skuValue.selectedSkuComb) {
        this.goodsDetail.goodsInfos.map((item, i) => {
          // if (skuValue.selectedSkuComb.id === item.partGoodsInfoId) {
          if (skuValue.selectedSkuComb.id === item.goodsInfoId) {
            this.ImagePreviewIndex = i;
            this.goods.picture = item.goodsInfoImg;
            return;
          }
        });
      } else {
        this.goods.picture = this.goodsImg;
      }
    },

    onBuyClicked(value) {
      console.log(value);
      // console.log(this)

        var minNum = this.goodsDetail.moq;
        if (value.selectedNum < minNum) {
          Toast({
            message: `起订数量为${minNum}件`,
            position: "center",
            duration: 1000,
          });
          return;
        } else {
          let selectedSku;
          this.goodsDetail.goodsInfos.map((i) => {
            if (value.selectedSkuComb.id === i.partGoodsInfoId) {
              selectedSku = i;
              return;
            }
            return "";
          });
          let sub = {
            orderGroups: [
              {
                actName: this.goodsDetail.actName,
                actId: this.goodsDetail.actId,
                limitedQuantity: this.goodsDetail.limitedQuantity,
                orders: [
                  {
                    partId: this.goodsDetail.partId,
                    items: [
                      {
                        goodsInfoName: selectedSku.goodsInfoName,
                        qty: value.selectedNum,
                        spuId: this.goodsDetail.goodsId,
                        actSpuId: this.goodsDetail.partGoodsId,
                        actSkuId: selectedSku.partGoodsInfoId,
                        skuId: selectedSku.goodsInfoId,
                      },
                    ],
                    brandName: this.goodsDetail.brandName,
                  },
                ],
              },
            ],
            suite: false,
          };

          console.log("sub", sub);
          this.$router.push({
            name: "Settle",
            params: {
              fid: 0,
              subData: sub,
            },
          });
        }
    },
    onAddCartClicked(e) {
      console.log(e);
      let subParams = {
        partGoodsInfoId: e.selectedSkuComb.id,
        goodsNum: e.selectedNum,
      };
      addCart(subParams).then((res) => {
        Toast({
          message: "成功",
          position: "center",
          duration: 1000,
        });
        this.show = false;
      });
    },

    generatePost() {
      console.log(location);
      let urlAddress;
      if (location.hostname === "localhost") {
        urlAddress =
          window.location.origin +
          location.pathname +
          "?customerId=" +
          this.$store.state.user.forwardId;
      } else {
        urlAddress =
          location.href + "?customerId=" + this.$store.state.user.forwardId;
      }
      this.urlAddress = urlAddress;
      let params = {
        actId: this.goodsDetail.actId,
        partId: this.goodsDetail.partId,
        partGoodsId: this.goodsDetail.partGoodsId,
        goodsId: this.goodsDetail.goodsId,
        retailId: null,
        markupType: "NONE",
        markupAmount: 0,
        markupRatio: 0,
        forwardType: "GOODS",
        price: 0,
        urlAddress,
      };
      switch (this.jiajiaway) {
        case 1:
          params.markupType = "NONE";
          params.price = this.goodsDetail.actPrice;
          break;
        case 2:
          params.markupType = "AMOUNT";
          params.markupAmount = 10;
          params.price = this.goodsDetail.actPrice + 10;
          break;
        case 3:
          params.markupType = "RATIO";
          params.markupRatio = 0.2;
          params.price = this.goodsDetail.actPrice * 1.2;
          break;
        case 4:
          if (!this.customjiajia) {
            return;
          }
          params.markupType = "AMOUNT";
          params.markupAmount = Number(this.customjiajia);
          params.price = this.goodsDetail.actPrice + Number(this.customjiajia);

          break;
        default:
          break;
      }
      console.log(params);
      priceMarkup(params).then(({ data }) => {
        // this.showShare = true;
        this.diagVisible = false;
        this.$store.dispatch("sharePoster/show", {
          url: data.url,
          title: this.goodsDetail.goodsName,
          desc: "",
          link: urlAddress,
          imgUrl: this.goodsDetail.goodsImages[0],
        });
      });
    },
    back() {
      if (this.$route.query.customerId || this.$route.params.customerId) {
        this.$router.push({ name: "Home" });
      } else {
        this.$router.back();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.img {
  display: inline-block;
  height: 30px;
  width: 104px;
}

.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
}

.activeSku {
  border: #e82035 1px solid !important;
}

.goods-detail {
  .van-tabs__line {
    z-index: 0;
  }

  .van-tab--active {
    color: #e82035;
  }

  .van-tabs__wrap {
    height: 2rem;
  }
}

.goods-detail > .van-hairline--bottom::after {
  border-bottom: 0;
}

.goods-detail .van-nav-bar__right:active {
  opacity: 100;
}

.title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .tit {
    flex: 1;
    min-width: 0;
    font-size: 32px;
    font-weight: 600;
    color: #333333;
    line-height: 40px;
  }

  .buy-quantity {
    min-width: 100px;
    font-size: 24px;
    font-weight: 400;
    color: #808080;
    line-height: 40px;
    text-align: right;
    margin-left: 20px;
  }
}

.swipContant {
  position: relative;
  .soldOutImg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 0 40px;
  }
}

.soldOutPrice {
  color: #808080 !important;
}
</style>
